module.exports = __webpack_public_path__ + "static/media/8.8ab80b03.svg";